module.exports = __webpack_public_path__ + "img/menuIcon8.04241707.png";